import React from 'react';
import cx from 'classnames';
import styles from '../create.module.css';

/** Track selection cards (Freelancer / Business). Disabled tracks are inert. */
export const TrackStep = ({ tracks, value, onSelect }) => (
  <div className={styles.optionsGrid}>
    {tracks.map((opt) => (
      <div
        key={opt.value}
        className={cx(
          styles.optionCard,
          value === opt.value && styles.optionCardSelected,
          opt.disabled && styles.optionCardDisabled
        )}
        role="button"
        tabIndex={opt.disabled ? -1 : 0}
        aria-disabled={opt.disabled}
        onClick={() => !opt.disabled && onSelect(opt.value)}
        onKeyDown={(e) => !opt.disabled && e.key === 'Enter' && onSelect(opt.value)}
      >
        <div className={styles.optionCardContent}>
          <span className={styles.optionLabel}>
            {opt.label}
            {opt.disabled && <span className={styles.comingSoon}>Coming soon</span>}
          </span>
          <span className={styles.optionDescription}>{opt.description}</span>
        </div>
        <div className={styles.optionRadio} />
      </div>
    ))}
  </div>
);
